import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Reputacion`

export function buscarReputacion(idVendedor) {
  return http.get(`${API_ENDPOINT}/BuscarReputacion/${idVendedor}`)
}
